<script>
    export let title;
    export let value;
    export let placeholder = title;
    export let error;
</script>

<style>
    textarea {
        width: 100%;
    }
</style>

<div class="field">
  <label class="label is-small">{title}</label>
  <div class="control">
    <textarea class="textarea is-small" placeholder={placeholder} bind:value class:is-danger={error}></textarea>
    {#if error}
        <p class="help is-danger">{error}</p>
    {/if}
  </div>
</div>